/**
 * An horizontal progress bar.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import { Box, LinearProgress } from '@mui/material'
import './HorizontalProgressBar.css'

const HorizontalProgressBar = () => {
  return (
    <Box className="horizontal-progress-bar">
      <LinearProgress className="linear-bar" />
    </Box>
  )
}

export default HorizontalProgressBar
